{
  "sidebar": {
    "profile": "Sama profil",
    "orders": "Sama komand yi",
    "addresses": "Sama adres yi",
    "returns": "Sama retuur yi",
    "invoices": "Sama faktiir yi",
    "logout": "Génn",
    "wishlist": "Sama yi ma bëgg",
    "settings": "Parameetar"
  },

  "login": {
    "title": "Dugg",
    "subtitle": "Dugg ci sa espace client Djayma",
    "email_label": "Adres e-mail",
    "email_placeholder": "sa@email.com",
    "password_label": "Baatu jàll",
    "password_placeholder": "Sa baatu jàll",
    "forgot_password": "Fàtte nga sa baatu jàll?",
    "submit": "Dugg",
    "no_account": "Amoo kont?",
    "create_account": "Sos ab kont",
    "success_registered": "Kont bi sos nañu ko. Mën nga dugg léegi.",
    "error_email_required": "Bind sa adres e-mail.",
    "error_password_required": "Bind sa baatu jàll.",
    "error_invalid_credentials": "E-mail walla baatu jàll baaxul.",
    "error_too_many_attempts": "Jéem yi bare na lool. Jéemal ko ci {{seconds}}s.",
    "error_generic": "Am na njuumte. Jéemal ko.",
    "show_password": "Yëgël baatu jàll bi",
    "hide_password": "Planqué baatu jàll bi",
    "reason_timeout": "Sa session def na jëpp. Duggal sa kont ci yoon wi.",
    "reason_login_required": "Duggal sa kont ngir gis sa xibaar bi."
  },

  "register": {
    "title": "Sos ab kont",
    "subtitle": "Bokk ci Djayma te def sa komand yi ci internet",
    "full_name_label": "Tur bu mat",
    "full_name_placeholder": "Sant ak tur",
    "email_label": "Adres e-mail",
    "email_placeholder": "sa@email.com",
    "phone_label": "Telefon",
    "phone_placeholder": "+221 77 123 45 67",
    "password_label": "Baatu jàll",
    "password_placeholder": "Lu tolluwul 8 karakteer",
    "password_confirm_label": "Dëggal baatu jàll bi",
    "password_confirm_placeholder": "Bind sa baatu jàll bi kenn",
    "privacy_accept": "Nangu naa",
    "privacy_policy_link": "politig suturlu",
    "privacy_and_terms": "ak cëru yi",
    "submit": "Sos sama kont",
    "already_account": "Am nga kont?",
    "login_link": "Dugg",
    "error_name_required": "Bind sa tur bu mat.",
    "error_email_required": "Bind sa adres e-mail.",
    "error_privacy_required": "War nga nangu politig suturlu bi ngir sos ab kont.",
    "error_phone_invalid": "Nimero telefon war na am format Senegaal (+221 XX XXX XX XX).",
    "error_password_min": "Baatu jàll bi war na am lu tolluwul 8 karakteer.",
    "error_password_mismatch": "Baatu jàll yi amul benn.",
    "error_generic": "Am na njuumte. Jéemal ko.",
    "show_password": "Yëgël baatu jàll bi",
    "hide_password": "Planqué baatu jàll bi",
    "show_confirm_password": "Yëgël dëggal baatu jàll bi",
    "hide_confirm_password": "Planqué dëggal baatu jàll bi"
  },

  "reset_request": {
    "title": "Fàtte baatu jàll",
    "subtitle": "Duggal sa adres e-mail ngir jot lien réinitialisasion.",
    "email_label": "Adres e-mail",
    "email_placeholder": "sa@email.com",
    "submit": "Yonnee lien bi",
    "back_to_login": "Dellu ci dugg",
    "sent_title": "E-mail yonnee na",
    "sent_message": "Bu am kont ci adres <strong>{{email}}</strong>, dinga jot lien réinitialisasion ci tuuti.",
    "check_spam": "Xoolal sa spam itam.",
    "error_generic": "Am na njuumte. Jéemal ko."
  },

  "reset_password": {
    "title": "Baatu jàll bu bees",
    "subtitle": "Tànnal baatu jàll bu bees ci sa kont.",
    "password_label": "Baatu jàll bu bees",
    "password_placeholder": "Lu tolluwul 8 karakteer",
    "password_confirm_label": "Dëggal baatu jàll bi",
    "password_confirm_placeholder": "Bind sa baatu jàll bi kenn",
    "submit": "Yéegal baatu jàll bi",
    "success_title": "Baatu jàll bi soppi na",
    "success_redirect": "Di la yóbbu ci sa espace client...",
    "expired_title": "Lien bi jeex na",
    "expired_message": "Lien bii baaxul walla jeex na. Ñaaneel benn bu bees.",
    "request_new_link": "Ñaaneel lien bu bees",
    "error_password_min": "Baatu jàll bi war na am lu tolluwul 8 karakteer.",
    "error_password_mismatch": "Baatu jàll yi amul benn.",
    "error_generic": "Am na njuumte. Jéemal ko.",
    "show_password": "Yëgël baatu jàll bi",
    "hide_password": "Planqué baatu jàll bi",
    "show_confirm_password": "Yëgël dëggal baatu jàll bi",
    "hide_confirm_password": "Planqué dëggal baatu jàll bi"
  },

  "profile": {
    "title": "Sama profil",
    "edit": "Soppi",
    "full_name_label": "Tur bu mat",
    "email_label": "Adres e-mail",
    "phone_label": "Telefon",
    "phone_placeholder": "+221 77 123 45 67",
    "phone_invalid": "Format telefon baaxul. Misaal : +221 77 123 45 67",
    "notifications_label": "Tànn ci notifikasion yi",
    "notification_email": "E-mail",
    "notification_sms": "SMS",
    "notification_whatsapp": "WhatsApp",
    "language_label": "Làkk bu la neex",
    "language_fr": "Français",
    "language_wo": "Wolof",
    "language_en": "Anglais",
    "save": "Denc",
    "cancel": "Neenal",
    "loading": "Yéegal profil bi...",
    "error_loading": "Mënuñu yéegal profil bi",
    "retry": "Jéemal ko",
    "success_message": "Profil bi soppi na ak jàmm.",
    "error_generic": "Am na njuumte."
  },

  "orders": {
    "title": "Sama komand yi",
    "empty_title": "Amul komand",
    "empty_message": "Sa komand yi dinañu feeñ fii bu ngay jënd.",
    "column_ref": "Referaas",
    "column_date": "Bés",
    "column_status": "Yoonu",
    "column_total": "Tollu TTC",
    "track": "Topp",
    "order_again": "Jënd kenn"
  },

  "addresses": {
    "title": "Sama adres yi",
    "add": "Yokk",
    "edit_title": "Soppi adres bi",
    "new_title": "Adres bu bees",
    "label_field": "Ëtt (mel ni : Kër, Bureau)",
    "label_placeholder": "Kër",
    "phone_label": "Telefon",
    "phone_placeholder": "+221 77 123 45 67",
    "address_label": "Adres bu mat",
    "address_placeholder": "Mbedd 12, Kër 45",
    "quartier_label": "Kërgi",
    "quartier_placeholder": "Hann Mariste",
    "commune_label": "Komiin",
    "commune_placeholder": "Hann Bel-Air",
    "region_label": "Régioon",
    "region_select": "Tànn",
    "update": "Yéegal",
    "save": "Denc",
    "cancel": "Neenal",
    "default_badge": "Njëkk",
    "set_default": "Def ko njëkk",
    "edit": "Soppi",
    "delete": "Far",
    "empty_title": "Amul adres",
    "empty_message": "Yokk ab adres indil ngir def komand.",
    "region_dakar": "Dakar",
    "region_kaolack": "Kaolack",
    "region_saint_louis": "Saint-Louis",
    "region_fatick": "Fatick",
    "region_thies_mbour": "Thiès-Mbour",
    "region_diourbel_touba": "Diourbel-Touba"
  },

  "returns": {
    "title": "Sama retuur yi",
    "request_button": "Ñaaneel retuur",
    "new_request_title": "Ñaane retuur bu bees",
    "close_form": "Tëj formuleer bi",
    "disabled_title": "Retuur yi jàppandiwuñu ci waxtu bii.",
    "disabled_contact": "Wàccal ñu ci WhatsApp ci",
    "empty_title": "Amul ñaane retuur.",
    "empty_hint": "Bësal ci « Ñaaneel retuur » ngir yonnee ñaane.",
    "loading_error": "Mënuñu yéegal sa ñaane retuur yi.",
    "column_order": "Komand",
    "column_date": "Bés",
    "column_reason": "Ngirte",
    "column_status": "Yoonu",
    "column_refund": "Fey delloo",
    "form_order_label": "Komand bi dal",
    "form_order_placeholder": "Tànn ab komand",
    "form_no_orders": "Amul komand bu agsi ngir retuur.",
    "form_reason_label": "Ngirte retuur bi",
    "form_reason_placeholder": "Tekkal njuumte bi ci sa komand (produwe bu yàq, bu baaxul, etc.)",
    "form_reason_count": "{{count}} / {{min}} karakteer bu gën a ndaw",
    "form_items_label": "Produwe yi ngay delloo",
    "form_items_hint": "du waajib — bàyyil ko su la neexee delloo komand bi yépp",
    "form_item_qty_available": "Limu am : {{qty}}",
    "form_item_qty_label": "Limu bu ngay delloo :",
    "form_item_reason_label": "Tekki ci produwe bii (du waajib)",
    "form_item_reason_placeholder": "Mel ni : Emballaas bu ubbi, produwe bu jeex...",
    "form_submit": "Yonnee ñaane bi",
    "form_submitting": "Yonnee ci kanam...",
    "form_cancel": "Neenal",
    "form_success_title": "Ñaane bi yonnee na",
    "form_success_message": "Sa ñaane retuur bi denc na.",
    "form_success_ref": "Réf. retuur : {{id}}",
    "form_success_contact": "Sunu ekip dina ko xool te wàcce la ci biir 48 waxtu.",
    "form_submit_error": "Njuumte ci yonnee bi (HTTP {{status}}). Jéemal ko.",
    "form_photos_label": "Nataal yi (du waajib)",
    "form_photos_hint": "Yokk ba 5 nataal (5 Mo bu gën a bari) ngir ndimbal ñu ci ñaane bi.",
    "form_photos_button": "Yokk nataal",
    "form_photo_size_error": "Yeneen nataal yi mag nañu lool 5 Mo. Tànnal yi gën a ndaw.",
    "form_photo_limit_error": "Mën ngay yokk rekk 5 nataal.",
    "policy_link": "Xoolal sunu politig retuur",
    "status_requested": "Ñaane na",
    "status_approved": "Nangu nañu ko",
    "status_rejected": "Bañ nañu ko",
    "status_refund_pending": "Fey delloo ci yoon",
    "status_refunded": "Delloo nañu fey bi",
    "status_closed": "Tëj nañu ko"
  },

  "order_status": {
    "pending": "Ngantu na",
    "confirmed": "Dëgg na",
    "processing": "Ñuy prepare",
    "shipped": "Yónn nañu ko",
    "delivered": "Agsi na",
    "cancelled": "Neenal na"
  },

  "login_title": "Dugg",
  "login_phone": "Nimero telefon",
  "login_otp": "Kodu dëggal",
  "send_otp": "Yonnee kodu bi",
  "verify": "Dëggal",
  "register_title": "Sos ab kont",
  "profile_legacy": "Sama profil",
  "orders_legacy": "Sama komand yi",
  "addresses_legacy": "Sama adres yi",
  "returns_legacy": "Sama retuur yi",
  "no_orders": "Amul komand",
  "order_again": "Jënd kenn",
  "tracking_title": "Topp komand",
  "tracking_search": "Duggal sa referaas komand",

  "wishlist": {
    "title": "Sama yi ma bëgg",
    "empty": "Amul produwe bu la neex",
    "empty_description": "Xoolal sunu katalog te yokk yi la neex",
    "remove": "Jële",
    "add_to_cart": "Yokk ci panier bi",
    "added_to_cart": "Yokk nañu ko ci panier bi",
    "removed": "Jële nañu ko ci yi la neex",
    "browse_catalog": "Xoolal katalog bi",
    "loading": "Yéegal yi la neex...",
    "error": "Mënuñu yéegal yi la neex",
    "retry": "Jéemal ko",
    "out_of_stock": "Jeex na",
    "share": "Séddal",
    "share_created": "Lien séddal sos nañu ko",
    "link_copied": "Lien bi kopi na!",
    "share_error": "Mënuñu sos lien séddal bi",
    "revoke_link": "Far lien bi",
    "share_revoked": "Lien séddal bi far nañu ko",
    "revoke_error": "Mënuñu far lien bi",
    "copy_link": "Kopi",
    "shared_loading": "Yéegal limu bëgg yi...",
    "shared_expired_title": "Lien bi jeex na walla far nañu ko",
    "shared_expired_description": "Lien séddal bii baaxul.",
    "shared_error": "Mënuñu yéegal lim bii",
    "shared_default_title": "Limu bëgg yi",
    "shared_by": "Limu bëgg yi bu {{name}}",
    "shared_empty": "Lim bii amul dara ci waxtu bii."
  },

  "settings": {
    "title": "Parameetar kont bi",
    "password_title": "Soppi baatu jàll bi",
    "password_current": "Baatu jàll bi tey",
    "password_new": "Baatu jàll bu bees",
    "password_new_placeholder": "Lu tolluwul 8 karakteer",
    "password_confirm": "Dëggal baatu jàll bu bees bi",
    "password_confirm_placeholder": "Bind baatu jàll bu bees bi kenn",
    "password_submit": "Soppi baatu jàll bi",
    "password_success": "Baatu jàll bi soppi na ak jàmm.",
    "password_error": "Mënuñu soppi baatu jàll bi.",
    "password_current_wrong": "Baatu jàll bi tey baaxul.",
    "password_min_error": "Baatu jàll bi war na am lu tolluwul 8 karakteer.",
    "password_mismatch_error": "Baatu jàll yi amul benn.",
    "notifications_title": "Tànn ci notifikasion yi",
    "notifications_description": "Tànnal naka ngay bëgg ñu xamal la",
    "channel_email": "E-mail",
    "channel_sms": "SMS",
    "channel_whatsapp": "WhatsApp",
    "prefs_updated": "Tànn yi soppi nañu",
    "export_title": "Yéene sama donee yi",
    "export_description": "Ci yoon wi Loi n° 2008-12 ngir aar donee suturlu yi ci Senegaal, mën nga téléchargee kopi sa donee yi yépp.",
    "export_button": "Téléchargee sama donee yi",
    "exporting": "Yéene ci kanam...",
    "export_success": "Donee yi yéene nañu",
    "export_error": "Mënuñu yéene sa donee yi",
    "delete_title": "Far sama kont",
    "delete_description": "Lii delluwul. Sa kont ak sa donee yi yépp dinañu leen far ci biir 30 fan.",
    "delete_button": "Ñaaneel farlu",
    "delete_confirm_title": "Dëggal farlu bi",
    "delete_confirm_message": "Ndax dëgg nga bëgg far sa kont? Lii delluwul.",
    "delete_reason_label": "Ngirte (du waajib)",
    "delete_reason_placeholder": "Nëbbal ñu ngir lan ngay génn...",
    "delete_confirm_button": "Dëggal farlu bi",
    "delete_cancel": "Neenal",
    "delete_success": "Sa ñaane farlu bi denc na. Dinañu ko traite ci biir 30 fan.",
    "delete_error": "Mënuñu yonnee ñaane farlu bi"
  },

  "order_detail": {
    "title": "Xam-xam ci komand bi",
    "reference": "Referaas",
    "date": "Bés",
    "items": "Produwe yi",
    "quantity": "Limu",
    "unit_price": "Prix benn",
    "line_total": "Tollu",
    "subtotal_ht": "Sous-total HT",
    "tva": "TVA",
    "delivery_fee": "Njëg indil",
    "total_ttc": "Tollu TTC",
    "payment": "Fey",
    "payment_method": "Yoon fey",
    "payment_status": "Yoonu fey bi",
    "delivery": "Indil",
    "delivery_address": "Adres indil",
    "delivery_status": "Yoonu indil bi",
    "estimated_delivery": "Indil bu ñu sàmm",
    "track": "Topp indil bi",
    "reorder": "Jënd kenn",
    "back": "Dellu ci komand yi",
    "not_found": "Gisuwuñu komand bi",
    "loading": "Yéegal...",
    "error": "Mënuñu yéegal komand bi"
  },

  "orders.view_detail": "Xool xam-xam",
  "orders.reorder": "Jënd kenn",
  "orders.reorder_success": "Produwe yi yokk nañu ci panier bi",
  "orders.reorder_error": "Mënuñu jënd kenn",
  "orders.loading": "Yéegal sa komand yi...",
  "orders.empty": "Amul komand",
  "orders.empty_description": "Sa komand yi dinañu feeñ fii bu ngay jënd.",
  "orders.reference": "Referaas",
  "orders.date": "Bés",
  "orders.status": "Yoonu",
  "orders.total": "Tollu",
  "orders.error": "Mënuñu yéegal sa komand yi",
  "orders.error_description": "Jéemal ko ci tuuti.",
  "orders.retry": "Jéemal ko",
  "orders.load_more": "Yéegal yeneen",
  "orders.loading_more": "Yéegal...",
  "orders.total_count": "{{count}} komand",
  "orders.total_count_plural": "{{count}} komand yi",

  "register.link_order_hint": "Sa komand bi dina bókk ci sa kont bu bees.",

  "email_verification": {
    "title": "Dëggal sa e-mail",
    "description": "E-mail dëggal yonnee nañu ko ci sa adres. Bësal ci lien bi ngir xàll sa kont.",
    "resend": "Yonnee e-mail bi kenn",
    "resent_success": "E-mail dëggal yonnee nañu ko kenn",
    "resend_no_email": "Neexal sa kont kenn ngir yonnee e-mail bi.",
    "resend_generic_error": "Mënul yonnee e-mail bi. Jéem kenn ci ay simili.",
    "spam_hint": "Su dara feesul ci 2 simili, nataal sa spam ci contact@cieda.sn.",
    "back_to_login": "Dellu ci dugg"
  }
}
